var moduleMap = {
	"./noop": function() {
		return Promise.all(/* __federation_expose_noop */[__webpack_require__.e(6579), __webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(297), __webpack_require__.e(5120)]).then(function() { return function() { return (__webpack_require__(56579)); }; });
	},
	"./react": function() {
		return __webpack_require__.e(/* __federation_expose_react */ 6593).then(function() { return function() { return (__webpack_require__(96540)); }; });
	},
	"./react-dom": function() {
		return Promise.all(/* __federation_expose_react_dom */[__webpack_require__.e(6593), __webpack_require__.e(8884)]).then(function() { return function() { return (__webpack_require__(40961)); }; });
	},
	"./next/router": function() {
		return Promise.all(/* __federation_expose_next__router */[__webpack_require__.e(7967), __webpack_require__.e(1688), __webpack_require__.e(1298), __webpack_require__.e(4106), __webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(5286)]).then(function() { return function() { return (__webpack_require__(86715)); }; });
	},
	"./Chip": function() {
		return Promise.all(/* __federation_expose_Chip */[__webpack_require__.e(3454), __webpack_require__.e(110)]).then(function() { return function() { return (__webpack_require__(70257)); }; });
	},
	"./Typography": function() {
		return Promise.all(/* __federation_expose_Typography */[__webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(3454), __webpack_require__.e(1151)]).then(function() { return function() { return (__webpack_require__(73003)); }; });
	},
	"./endpoints.configs": function() {
		return __webpack_require__.e(/* __federation_expose_endpoints.configs */ 429).then(function() { return function() { return (__webpack_require__(69194)); }; });
	},
	"./Dialog": function() {
		return Promise.all(/* __federation_expose_Dialog */[__webpack_require__.e(4106), __webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(3454), __webpack_require__.e(1151), __webpack_require__.e(5535), __webpack_require__.e(1056)]).then(function() { return function() { return (__webpack_require__(78521)); }; });
	},
	"./Button": function() {
		return Promise.all(/* __federation_expose_Button */[__webpack_require__.e(7996), __webpack_require__.e(7831), __webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(3454), __webpack_require__.e(1151), __webpack_require__.e(297), __webpack_require__.e(5535), __webpack_require__.e(1836)]).then(function() { return function() { return (__webpack_require__(29207)); }; });
	},
	"./Skeleton": function() {
		return Promise.all(/* __federation_expose_Skeleton */[__webpack_require__.e(3454), __webpack_require__.e(1573)]).then(function() { return function() { return (__webpack_require__(7663)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
__webpack_require__(58879)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});